import React from 'react';

import '../../styles/sass/shop/shop-on-loader.sass';


const ShopOnLoader = () => {


    return (
        <div className="loading">
            <i className="fas fa-spinner"></i>
            <p>Loading</p>
        </div>
    )

}


export default ShopOnLoader;